import { ReactNode } from "react";
import { AuthUser } from "~/auth.server";
import { Realm, tturl } from "~/util/Lang";
import { Header } from "./site/Header";
import { BannerBlock } from "./blocs/BannerBlock";
import { MainMenu } from "./site/MainMenu";
import { GverMenu } from "./site/GverMenu";
import { matchPath, useLocation } from "react-router";
import { Footer } from "./site/Footer";
import clsx from "clsx";

export function Layout(props: {
  children: ReactNode;
  realm: Realm;
  authUser: AuthUser | null;
}) {
  const { authUser } = props;
  const location = useLocation();
  const turl = tturl.bind(null, props.realm);

  function normalizePath(path: string) {
    return path.endsWith("/") && path !== "/" ? path.slice(0, -1) : path;
  }

  function isHome() {
    return normalizePath(location.pathname) === normalizePath(turl("/"));
  }

  const isEditPage = [
    "/quests/:quest/edit-page",
    "/npcs/:npc/edit-page",
    "/items/:item/edit-page",
    "/users/:user/pages/:page/edit",
    "/wiki/:page/edit",
  ].some((pattern) => matchPath(pattern, location.pathname));

  if (isEditPage) {
    return <>{props.children}</>; // без layout
  }

  return (
    <>
      <Header authUser={authUser} />
      <BannerBlock />
      <MainMenu isHome={isHome()} />
      <div
        className={clsx("container", {
          ["main"]: !isHome(),
        })}
      >
        {!isHome() && <GverMenu />}
        {props.children}
      </div>
      <Footer />
    </>
  );
}
